import {useState, Fragment} from 'react'
import {useForm} from 'react-hook-form'

import Button from '@mui/material/Button'
import Paper from '@mui/material/Paper'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'

import FormWrapper from '../../shared/FormWrapper'
import Email from '../../shared/Email'

import {connect} from '../../../state/hooks/tools'
import {createResource} from '../../../lib/asyncMethods'
import {FORGOT_PASSWORD} from '../../../state/actionTypes'

import './forgotPassword.scss'

const ForgotPassword = props => {
  const [state, setState] = useState({})
  const methods = useForm()
  const {errors} = methods.formState

  const handleSubmit = data => {
    setState(prevState => ({...prevState, loading: true}))

    props.createResource({endpoint: 'passwords/forgot-password', attributes: data}).then(response => {
      if (response.success)
        setState(prevState => ({...prevState, message: response.message}))
    }).finally(() => setState(prevState => ({...prevState, loading: false})))
  }

  return (
    <Fragment>
      {
        state.message?.length > 0 ? (
          <Stack className='message'>
            <Typography variant='body1'>{state.message}</Typography>
          </Stack>
        ) : (
          <Paper elevation={3} component='div' className='forgot-password'>
            <Typography variant='h5' gutterBottom>Forgot Password</Typography>
            <FormWrapper methods={methods} handleSubmit={handleSubmit}>
              <Email error={!!errors.email} helperText={errors.email?.message} />
              <Button
                disabled={state.loading}
                type='submit'
                variant='contained'
                sx={{color: '#F7F7F7'}}>
                Submit
              </Button>
            </FormWrapper>
          </Paper>
        )
      }
    </Fragment>
  )
}

const actionCreators = ({auth}) => ({createResource: createResource(auth, FORGOT_PASSWORD)})

export default connect(null, actionCreators)(ForgotPassword)
